export function getFlexBasis(elementsPerRow, gapPerRow) {
  return `calc((100% - ${elementsPerRow - 1} * ${gapPerRow}) / ${elementsPerRow})`
}
